import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useMillAuth } from '../contexts/MillAuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const MillProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, loading } = useMillAuth();
  const location = useLocation();

  // Wait for auth check to complete before redirecting
  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
        <p>Loading...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Clear stale localStorage to prevent login page bounce-back loop
    localStorage.removeItem('rbf_user_data');
    localStorage.removeItem('user');
    // Redirect to shared team login with return path
    return <Navigate to={`/login?next=${encodeURIComponent(location.pathname)}`} replace />;
  }

  return <>{children}</>;
};

export default MillProtectedRoute;
